// extracted by mini-css-extract-plugin
export default {"footer":"sb_lNb"};